module.exports = "/static/assets/41dfa445485f7a81540bded1568a600f.png";